import { render, staticRenderFns } from "./AppointmentFormNCP.vue?vue&type=template&id=5ba6986a&scoped=true"
import script from "./AppointmentFormNCP.vue?vue&type=script&lang=js"
export * from "./AppointmentFormNCP.vue?vue&type=script&lang=js"
import style0 from "./AppointmentFormNCP.vue?vue&type=style&index=0&id=5ba6986a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba6986a",
  null
  
)

export default component.exports